<template>
    <div class="contactUs">
        <!-- <div class="headline">{{ $t('headline.title6') }}</div> -->
        <div class="main">
            <div class="box1">
                <div class="title">{{ $t('contactUs.title1') }}</div>
                <div class="address">{{ $t('contactUs.content11') }}：{{ $t('contactUs.content14') }}</div>
                <div class="phone">{{ $t('contactUs.content12') }}：18958077780{{ $t('contactUs.content15') }}</div>
                <div class="email">{{ $t('contactUs.content13') }}：zhexinsiwei@4d-ai.chat</div>
                <div class="mapBox">
                    <Amap />
                </div>
            </div>
            <div class="box2">
                <div class="servesList">
                    <div class="title">{{ $t('contactUs.title2') }}</div>
                    <div>{{ $t('contactUs.content21') }}</div>
                    <div>{{ $t('contactUs.content22') }}</div>
                    <div>{{ $t('contactUs.content23') }}</div>
                    <div>{{ $t('contactUs.content24') }}</div>
                    <div>{{ $t('contactUs.content25') }}</div>
                    <div @click="jumpTo()">{{ $t('contactUs.content26') }}</div>
                </div>
            </div>
            <div class="box3">
                <div class="title">{{ $t('contactUs.title8') }}</div>
                <div class="list">
                    <div class="codeBox">
                        <div class="title2">{{ $t('contactUs.title3') }}</div>
                        <img :src="`https://4d-ai.chat/img/${$t('img.code')}.jpg`">
                    </div>
                    <div class="codeBox">
                        <div class="title2">{{ $t('contactUs.title4') }}</div>
                        <img :src="`https://4d-ai.chat/img/${$t('img.xcxercode')}.jpg`">
                    </div>
                </div>
            </div>
        </div>
        <div class="filing" @click="toBack">
            © {{ year }} {{ $t('contactUs.title5') }}. {{ $t('contactUs.title6') }}. {{ $t('contactUs.title7') }}
        </div>
    </div>
</template>
<script>
import Amap from '@/components/Amap.vue';
export default {
    components: {
        Amap,
    },
    data() {
        return {
            year: null,
        }
    },
    created() {
        let date = new Date()
        this.year = date.getFullYear()
    },
    mounted() {

    },
    methods: {
        jumpTo() {
            if (this.$route.path == '/aboutUs') {
                return
            }
            this.$router.push('/aboutUs')
        },
        toBack() {
            window.open('https://beian.miit.gov.cn/#/Integrated/index', '_blank');
        },
    }
}
</script>
<style scoped lang="less">
@media (max-width: 768px) {
    .contactUs {
        padding: 10px !important;
    }

    .main {
        flex-direction: column !important;
    }

    .box1 {
        margin-bottom: 10px !important;

        .mapBox {
            height: 200px !important;
        }

        .title {
            font-size: 16px !important;
            margin-bottom: 10px !important;
        }

        .address,
        .email,
        .phone {
            font-size: 12px !important;
            margin-bottom: 10px !important;
        }
    }

    .box2 {
        width: 100% !important;

        .servesList {
            width: 100% !important;

            .title {
                width: 100% !important;
                font-size: 16px !important;
            }

            div {
                width: 50% !important;
                display: inline-block !important;
                font-size: 12px !important;
                margin-bottom: 10px !important;
            }
        }
    }

    .box3 {
        width: 100% !important;
        margin-bottom: 10px !important;

        .title {
            width: 100% !important;
            font-size: 16px !important;
            font-weight: 600 !important;
            margin-bottom: 10px !important;
        }

        .list {
            width: 100% !important;
            display: flex !important;
            flex-direction: row !important;

            .codeBox {
                flex: 1 !important;
                margin-bottom: 0 !important;

                .title2 {
                    flex: 1;
                    font-size: 12px !important;
                    display: flex;
                    margin-bottom: 10px !important;
                }

                img {
                    width: 120px !important;
                }
            }
        }
    }

    .filing {
        border-top: 1px solid #2743af !important;
        margin-top: 20px !important;
        font-size: 12px !important;
        color: #9ac6fd !important;
    }
}
</style>
<style scoped lang="less">
.contactUs {
    background-color: #243c8a;
    padding: 80px 212px 24px;
    box-sizing: border-box;

    .main {
        width: 100%;
        display: flex;

        .box3 {
            box-sizing: border-box;
            color: #fff;
            display: flex;
            width: 300px;
            align-items: center;
            flex-direction: column;

            .title {
                font-size: 20px;
                font-weight: 600;
                margin-bottom: 20px;
                width: 120px;
            }

            .list {
                display: flex;
                flex: 1;
                flex-direction: column;

                .codeBox {
                    margin-bottom: 20px;

                    .title2 {
                        cursor: pointer;
                        flex: 1;
                        font-size: 16px;
                        display: flex;
                        margin-bottom: 20px;
                    }

                    img {
                        width: 120px;
                    }
                }
            }
        }

        .box2 {
            width: 300px;
            box-sizing: border-box;
            color: #fff;
            display: flex;
            flex-direction: column;
            align-items: center;

            .servesList {
                flex: 1;

                .title {
                    font-size: 20px;
                    font-weight: 600;
                    margin-bottom: 20px;
                }

                div {
                    cursor: pointer;
                    flex: 1;
                    font-size: 16px;
                    display: flex;
                    margin-bottom: 20px;
                }
            }
        }

        .box1 {
            flex: 1;
            color: #fff;
            box-sizing: border-box;

            .title {
                font-size: 20px;
                font-weight: 600;
                margin-bottom: 20px;
            }

            .address {
                font-size: 16px;
                margin-bottom: 20px;
            }

            .email {
                font-size: 16px;
                margin-bottom: 20px;
            }

            .phone {
                font-size: 16px;
                margin-bottom: 20px;
            }

            .mapBox {
                width: 100%;
                height: 400px;
                background-color: #fff;
                border-radius: 15px;
                overflow: hidden;
            }


        }
    }

    .headline {
        font-weight: 600;
        font-size: 36px;
        color: #fff;
        text-align: center;
        margin-bottom: 64px;
    }

    .filing {
        cursor: pointer;
        padding-top: 24px;
        border-top: 1px solid #2743af;
        margin-top: 40px;
        font-size: 16px;
        color: #9ac6fd;
        text-align: center;
        box-sizing: border-box;
    }
}

.headline {
    font-weight: 600;
    font-size: 36px;
    color: #243c8a;
    text-align: center;
    margin-bottom: 64px;
}
</style>